import { useState } from "react";
import { useTranslation } from "react-i18next";

// The initial `.dark` class is set by the inline script in public/index.html
// (before React paints), so we seed state from the DOM rather than re-deciding.
const isDark = () => document.documentElement.classList.contains("dark");

export default function ThemeToggle() {
  const { t } = useTranslation();
  const [dark, setDark] = useState(isDark);

  const toggle = () => {
    const next = !dark;
    document.documentElement.classList.toggle("dark", next);
    localStorage.setItem("theme", next ? "dark" : "light");
    setDark(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      aria-pressed={dark}
      aria-label={t(dark ? "nav.lightMode" : "nav.darkMode")}
      title={t(dark ? "nav.lightMode" : "nav.darkMode")}
      className="grid h-9 w-9 place-items-center rounded-full border border-hairline bg-surface
                 text-ink transition-colors hover:border-apricot focus:outline focus:outline-2
                 focus:outline-apricot"
    >
      {dark ? (
        // Sun — click to go light
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
             strokeWidth="2" strokeLinecap="round" aria-hidden="true">
          <circle cx="12" cy="12" r="4" />
          <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
        </svg>
      ) : (
        // Moon — click to go dark
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
        </svg>
      )}
    </button>
  );
}
